module.exports = __webpack_public_path__ + "static/media/disabledNextIcon.573c0bd0.svg";